import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../.././util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function selectedNoteIdReducer(state = initialState.rnhSelectedNote, action) {
	switch (action.type) {
		case types.SET_RNH_SELECTED_NOTE_ID: {
			return action.note;
		}
		case types.SET_RNH_SELECTED_NOTE_ID_RESET_CONTEXT: {
			return action.selectedNote;
		}
		case types.CLEAN_RNH_SELECTED_NOTE_ID: {
			return initialState.rnhSelectedNote;
		}
		case types.UPDATE_RNH_MULTIPLE_NOTES_BULK_CONTEXT: {
			return initialState.rnhSelectedNote;
		}
		case types.DELETE_RNH_NOTE: {
			if (
				action.responseObj &&
				(action.responseObj.status === HttpStatusCodes.NoContent || action.responseObj.status === HttpStatusCodes.Ok) &&
				state &&
				state.noteId === action.noteId
			) {
				return {noteId: null, entityId: 0};
			}
			return state;
		}
		default:
			return state;
	}
}
